module.exports = __webpack_public_path__ + "img/banner-legal.215b00f7.jpg";